<template>
    <ul  class="list-group list-group-flush tx-13">
        <li  v-for="item in benlist" :key="item.id" class="list-group-item d-flex pd-sm-x-20">
            <div class="avatar"><span class="avatar-initial rounded-circle bg-gray-600">{{ item.counterparty[0] }}</span></div>
            <div class="pd-l-10">
                <p class="tx-medium mg-b-0">{{ item.counterparty }}</p>
                <small class="tx-12 tx-color-03 mg-b-0">Account #{{ item.counterpartyaccount }}</small>
            </div>
            <div class="mg-l-auto d-flex align-self-center">
                <nav class="nav nav-icon-only">
                    <a href="" class="nav-link d-none d-sm-block"><mail-icon></mail-icon></a>
                    <a href="" class="nav-link d-none d-sm-block"><slash-icon></slash-icon></a>
                    <a href="" class="nav-link d-none d-sm-block"><user-icon></user-icon></a>
                    <a href="" class="nav-link d-sm-none"><more-vertical-icon></more-vertical-icon></a>
                </nav>
            </div>
        </li>
    </ul>
</template>
<script>
    import {MailIcon, SlashIcon, UserIcon, MoreVerticalIcon } from "vue-feather-icons"
    export default {

        props: ['benlist'],
        name: 'BeneficiaryList',
        components:{
            MailIcon, SlashIcon, UserIcon, MoreVerticalIcon
        }

    }
</script>
